{
    "profile": {
        "prefix": "profile",
        "hideNav": true,
        "nav": {
            "id": "profile",
            "title": "Profile",
            "type": "group",
            "children": [
                {
                    "id": "profile.account",
                    "title": "Account",
                    "type": "basic",
                    "link": "/profile/account"
                },
                {
                    "id": "profile.security",
                    "title": "Security",
                    "type": "basic",
                    "link": "/profile/security"
                }
            ]
        }
    },
    "office-profile": {
        "prefix": "profile",
        "hideNav": true,
        "nav": {
            "id": "profile",
            "title": "Profile",
            "type": "group",
            "children": [
                {
                    "id": "profile.account",
                    "title": "Account",
                    "type": "basic",
                    "link": "/profile/account"
                },
                {
                    "id": "profile.security",
                    "title": "Security",
                    "type": "basic",
                    "link": "/profile/security"
                },
                {
                    "id": "profile.billing",
                    "title": "Billing",
                    "type": "basic",
                    "link": "/profile/billing"
                },
                {
                    "id": "profile.subscription",
                    "title": "Subscription",
                    "type": "basic",
                    "link": "/profile/subscription"
                }
            ]
        }
    }
}
